module.exports = __webpack_public_path__ + "static/media/uploadIcon.a7f36c56.svg";